var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccepted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26.9189,
    height: 28,
    rx: 13.4595,
    fill: "#39B165"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7997 8.47037C20.1114 8.70783 20.1715 9.15299 19.934 9.46466L12.3665 19.3971C12.2424 19.5599 12.054 19.6612 11.8498 19.675C11.6455 19.6887 11.4453 19.6136 11.3005 19.4688L7.04373 15.212C6.76667 14.935 6.76667 14.4858 7.04373 14.2087C7.32079 13.9316 7.77 13.9316 8.04706 14.2087L11.7298 17.8914L18.8054 8.60473C19.0429 8.29306 19.488 8.2329 19.7997 8.47037Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccepted);
export default __webpack_public_path__ + "static/media/accepted.ab611887bc4962ac64f7c34514352be9.svg";
export { ForwardRef as ReactComponent };